import {
  TMaterialRequestListingItemDTO,
  TDetailedInfoForMaterialRequestOrderDTO,
  TRESPONSE_MaterialRequestCounts,
  TRESPONSE_GetMaterialRequestsListing,
  TFabricItemDTO,
  TTrimItemDTO,
} from './material-requests.types';
import {
  TRESPONSE_FabricGRNLotDetails,
  TRESPONSE_FabricGRNLotListing,
  TRESPONSE_TrimsGRNLotDetails,
  TRESPONSE_TrimsGRNLotListing,
} from './create-grn.types';
import {
  TRESPONSE_AvailableLocationsListing,
  TRESPONSE_GetNewLocationDetails,
  TRESPONSE_ItemsStoredInLocationDetails,
} from './transfer.types';
import {
  TRESPONSE_FabricStorageGRNDetails,
  TRESPONSE_FabricStorageRollsDetails,
  TRESPONSE_TrimsStorageGRNDetails,
  TRESPONSE_TrimsStorageItemDetails,
  TWarehouseDetailsPageState,
} from './storage.types';

export type TCreateGrnStoreState = {
  lotListing: {
    FABRIC: {
      res?: TRESPONSE_FabricGRNLotListing;
    };
    TRIMS: {
      res?: TRESPONSE_TrimsGRNLotListing;
    };
  };
  lotDetails: {
    FABRIC: {
      res?: TRESPONSE_FabricGRNLotDetails;
    };
    TRIMS: {
      res?: TRESPONSE_TrimsGRNLotDetails;
    };
  };
};

export type TStorageStoreState = {
  GRNDetails: {
    FABRIC: {
      res?: TRESPONSE_FabricStorageGRNDetails;
    };
    TRIMS: {
      res?: TRESPONSE_TrimsStorageGRNDetails;
    };
  };
  RollsAndItemsDetails: {
    FABRIC: {
      res?: TRESPONSE_FabricStorageRollsDetails;
    };
    TRIMS: {
      res?: TRESPONSE_TrimsStorageItemDetails;
    };
  };
};

export type TMaterialRequestStoreState = {
  materialRequestCounts: {
    lastUpdatedAt: number | null;
    counts: {
      res?: TRESPONSE_MaterialRequestCounts['materialRequestCounts'];
    };
  };
  warehouseMaterialRequests: {
    res?: TRESPONSE_GetMaterialRequestsListing;
  };
  materialRequestDetails: {
    res?: {
      FABRIC: TDetailedInfoForMaterialRequestOrderDTO[];
      TRIMS: TDetailedInfoForMaterialRequestOrderDTO[];
      receiverLocationId: string;
    };
  };
  selectedMaterialRequestOrderItem: TMaterialRequestListingItemDTO | null;
  addedItemsToSelectedMaterialRequestOrder: {
    FABRIC: Record<string, TFabricItemDTO[]>;
    TRIMS: Record<string, TTrimItemDTO[]>;
  };
};

export type TTransferStoreState = {
  availableLocationsListing: {
    res?: TRESPONSE_AvailableLocationsListing;
  };
  itemsStoredDetails: {
    res?: TRESPONSE_ItemsStoredInLocationDetails;
  };
  newLocationDetails: {
    res?: TRESPONSE_GetNewLocationDetails;
  };
};

export type TOrganizi8AppDetails = {
  factoryId: string;
  userWarehouseId: string;
};

export type TGRNLotListingActionClickDTO = {
  itemType: string;
  accordianId: string | number;
};

export enum EGRNLotListingModuleType {
  CREATE_GRN = 'CREATE_GRN',
  STORAGE = 'STORAGE',
}

export type TSubRouteStatusTabDetails = {
  status: string;
  displayName: string;
}[];

export enum EItemType {
  FABRIC_INSPECTION = 'FABRIC_INSPECTION',
  TRIMS_INSPECTION = 'TRIMS_INSPECTION',
}

export enum EGRNGenerationStatus {
  GENERATED = 'GENERATED',
  NOT_GENERATED = 'NOT_GENERATED',
  REJECTED = 'REJECTED',
}

export type TFabricTrimParam = 'FABRIC' | 'TRIMS';

export type TDetailedCardInfoDTO = { key: string; value: string | number };

export type TZfTabsDTO = { key: string; displayName: string };

export type TCardInfoTypes =
  | 'FABRIC_GRN_LOT_DETAILS'
  | 'TRIMS_GRN_LOT_DETAILS'
  | 'MATERIAL_REQUESTS_DETAILED_INFO'
  | 'MATERIAL_REQUESTS_ITEM_DETAILS'
  | 'TRANSFER_LOCATION_INFO'
  | 'TRANSFER_TO_LOCATION_INFO'
  | 'SELECTED_GRN_DETAILS'
  | 'WAREHOUSE_DETAILS';

export type TCardInfoDataTypes =
  | TMaterialRequestListingItemDTO
  | TDetailedInfoForMaterialRequestOrderDTO
  | TRESPONSE_FabricGRNLotDetails['lotInfo']
  | TRESPONSE_TrimsGRNLotDetails['trimInspectionLotModel']
  | TRESPONSE_ItemsStoredInLocationDetails['locationDetails']
  | TWarehouseDetailsPageState['selectedGRNDetails']
  | TWarehouseDetailsPageState['warehouseDetails'];

export type TOrganizi8CustomTableTextRow = {
  type: 'TEXT';
  values: (string | number)[];
};

export type TOrganizi8CustomTableStatusRow = {
  type: 'STATUS';
  statusText: string;
  color: 'SUCCESS' | 'FAILURE';
  value: string;
};

export type TOrganizi8CustomTableEditableRow = {
  type: 'EDITABLE_TEXT';
  value: number;
};

export type TCreateGRNSelectItemsListingTableRowItems = {
  ids: string[]; // it would contain multiple values if GRN was generated for multiple rolls in a single transaction
  colItems: (TOrganizi8CustomTableTextRow | TOrganizi8CustomTableStatusRow | TOrganizi8CustomTableEditableRow)[];
  checkbox?: {
    isCheckboxRequired: boolean;
    isSelected: boolean;
  };
  delete?: boolean;
}[];

export type TCreateGRNSelectItemsListingTableData = {
  headers: {
    label: string;
    colSize: number;
  }[];
  rowItems: TCreateGRNSelectItemsListingTableRowItems;
};

export type TOrganizi8ZfTabs = TZfTabsDTO[];

export type TModalForCustomDateAndRemarksMetadata = {
  date: string | null;
  remarks: string | null;
};
